<template>
  <div>
    <div class="card border-0 shadow-sm rounded-4 mb-3">
      <div class="card-body">
        <h6 class="fw-bold mb-2"><i class="bi bi-clock-history me-1 text-primary"></i>Consultations précédentes</h6>
        <div v-if="!historique.length" class="small text-muted">Première consultation dans la clinique.</div>
        <div v-for="h in historique" :key="h.id" class="histo mb-2">
          <button type="button" class="btn btn-link p-0 text-start w-100 text-decoration-none" @click="ouvert = ouvert === h.id ? null : h.id">
            <div class="d-flex justify-content-between small">
              <strong>{{ date(h.date) }}</strong><span class="text-muted">{{ h.type }}</span>
            </div>
            <div class="small text-dark">{{ resume(h) }}</div>
          </button>
          <div v-if="ouvert === h.id" class="small mt-1 ps-2 border-start">
            <div v-if="h.medecin" class="text-muted">{{ h.medecin }}</div>
            <div v-if="h.motif"><strong>Motif :</strong> {{ h.motif }}</div>
            <div v-if="h.traitement.length"><strong>Traitement :</strong>
              <ul class="mb-1 ps-3"><li v-for="t in h.traitement" :key="t">{{ t }}</li></ul>
            </div>
            <div v-if="h.conduiteATenir"><strong>Conduite :</strong> {{ h.conduiteATenir }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="resultats.length" class="card border-0 shadow-sm rounded-4 mb-3">
      <div class="card-body">
        <h6 class="fw-bold mb-2"><i class="bi bi-clipboard2-pulse me-1 text-success"></i>Derniers résultats</h6>
        <div v-for="r in resultats" :key="r.id" class="small mb-2">
          <div class="d-flex justify-content-between"><strong>{{ r.type }}</strong><span class="text-muted">{{ date(r.dateResultat) }}</span></div>
          <div v-for="p in (r.resultatsDetailles || []).slice(0, 4)" :key="p.nom" :class="{ 'text-danger fw-semibold': p.anormal }">{{ p.nom }} : {{ p.valeur }} {{ p.unite }}</div>
          <div v-if="r.resultat && !(r.resultatsDetailles || []).length">{{ r.resultat }}</div>
          <div v-if="r.conclusion" class="fst-italic">{{ r.conclusion }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'HistoriquePatient',
  props: { historique: { type: Array, default: () => [] }, resultats: { type: Array, default: () => [] } },
  data() {
    return { ouvert: null }
  },
  methods: {
    date(d) { return d ? dayjs(d).format('DD/MM/YYYY') : '' },
    resume(h) {
      const d = (h.diagnostics || []).map(x => x.libelle).join(', ')
      return d || h.motif || h.statut || ''
    },
  },
}
</script>

<style scoped>
.histo { border-bottom: 1px dashed #e3e8ef; padding-bottom: 6px; }
</style>
